// Extract "GET" parameters from a JS include querystring
function getParams(script_id) {
    var pa = document.getElementById(script_id).src.split("?").pop().split("&");
    var p = {};
    for(var j=0; j<pa.length; j++) {
        var kv = pa[j].split("=");
        p[kv[0]] = kv[1];
    }
    return p;
}